__turbopack_context__.v({
  "partners": "Providers-module-scss-module__6nWKwq__partners",
  "providerCount": "Providers-module-scss-module__6nWKwq__providerCount",
});
